import nameModelValidator from 'forms/shared/validators/models/name/name';
import { DEFAULT_LATEST } from 'constants/dateLimits';
import { hasYesOrNo } from 'models/validate';

import { ValidateJSModel } from 'forms/shared/types';
import currencyModelValidator from 'forms/shared/validators/models/currency';
import { FinancialAlimonyItemModel } from '../types';
import { pvqAlimonyValidator } from './pvqAlimonyLocationValidator';

export const financialAlimonyItemValidator: ValidateJSModel<FinancialAlimonyItemModel> = {
  /** Alimony is PVQ ONLY */

  RecipientName: {
    presence: true,
    model: {
      validator: nameModelValidator
    },
  },
  AmountRequiredToPay: {
    presence: true,
    model: {
      validator: currencyModelValidator,
    },
  },
  AmountPastDue: {
    presence: true,
    model: {
      validator: currencyModelValidator,
    },
  },
  AmountPastDueEstimated: {},
  ReasonPastDue: { hasValue: true },
  WhenPastDue: (value, attributes, attributeName, options) => {
    const { applicantBirthdate } = options;
    return {
      presence: true,
      date: { earliest: applicantBirthdate, latest: DEFAULT_LATEST },
    };
  },
  WhenPastDueEstimated: {},
  CurrentlyPastDue: {
    hasValue: { validator: hasYesOrNo },
  },
  WhenBecameCurrent: (value, attributes, attributeName, options) => {
    const { applicantBirthdate } = options;
    if (attributes?.CurrentlyPastDue?.value === 'No') {
      return {
        presence: true,
        date: { earliest: applicantBirthdate, latest: DEFAULT_LATEST },
      };
    }

    return {};
  },
  WhenBecameCurrentEstimated: {},
  ActionsTaken: (value, attributes) => {
    if (attributes?.ActionsTakenNone?.applicable !== false && attributes?.CurrentlyPastDue?.value === 'Yes') {
      return { hasValue: true };
    }

    return {};
  },
  ActionsTakenReason: (value, attributes) => {
    if (attributes?.ActionsTakenNone?.applicable === false && attributes?.CurrentlyPastDue?.value === 'Yes') {
      return { hasValue: true };
    }

    return {};
  },
  CourtName: { hasValue: true },
  CourtLocation: {
    presence: true,
    location: {
      validator: pvqAlimonyValidator,
    },
  },
  OrderNum: (value, attributes) => {
    if (attributes?.OrderNumIdk?.applicable !== false) {
      return {
        presence: true,
        hasValue: true
      };
    }
    return {};
  },
  OrderNumIdk: {},
};
